<template>
  <div>
    <FreelancersMenu menu="tabulator" :type="type"></FreelancersMenu><br />
    <CCard>
      <CCardHeader>
        <slot name="header">
          Tabulador de Visitas
        </slot>
      </CCardHeader>
      <CCardBody>
        <CRow style="margin-bottom: 12px;">
          <CCol md="3"><input class="form-control" type="number" min="1" v-model="newItem.min_visits" placeholder="Límite inferior" /></CCol>
          <CCol md="3"><input class="form-control" type="number" min="1" v-model="newItem.max_visits" placeholder="Límite superior (opcional)" /></CCol>
          <CCol md="3"><input class="form-control" type="number" min="0" step="0.01" v-model="newItem.amount_per_visit" placeholder="Monto por visita" /></CCol>
          <CCol md="3"><CButton color="success" size="sm" @click="storeItem()">Agregar</CButton></CCol>
        </CRow>

        <CDataTable
          :hover="true"
          :striped="true"
          :border="true"
          :small="true"
          :fixed="true"
          :items="items"
          :fields="fields"
          :dark="false"
          style="width: 100%; font-size: 11px;"
        >
          <template #min_visits="{item}"><td><input class="form-control" type="number" min="1" v-model="item.min_visits" /></td></template>
          <template #max_visits="{item}"><td><input class="form-control" type="number" min="1" v-model="item.max_visits" placeholder="Sin límite" /></td></template>
          <template #amount_per_visit="{item}"><td><input class="form-control" type="number" min="0" step="0.01" v-model="item.amount_per_visit" /></td></template>
          <template #actions="{item}">
            <td>
              <CButton color="info" size="sm" @click="updateItem(item)">Guardar</CButton>
              <CButton color="danger" size="sm" @click="deleteItem(item)" style="margin-left: 6px;">Eliminar</CButton>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import store from '../../store'
import ws from '../../services/freelancers'
import FreelancersMenu from './FreelancersMenu.vue'

export default {
  name: 'FreelanceVisitTabulator',
  components: {
    FreelancersMenu
  },
  data () {
    return {
      type: 'administrator',
      items: [],
      fields: [
        {key: 'min_visits', label: 'Límite inferior'},
        {key: 'max_visits', label: 'Límite superior'},
        {key: 'amount_per_visit', label: 'Monto por Visita'},
        {key: 'actions', label: 'Acciones'}
      ],
      newItem: {
        min_visits: 1,
        max_visits: '',
        amount_per_visit: 0
      }
    }
  },
  async mounted () {
    const is_superadmin = localStorage.getItem('is_superadmin')
    const is_administrator = localStorage.getItem('is_administrator')

    if(is_superadmin == 'true'){
      this.type = 'superadmin'
    }

    if(is_superadmin != 'true' && is_administrator != 'true'){
      window.location.href = '/#/home'
      return
    }

    await this.loadItems()
  },
  methods: {
    async loadItems () {
      this.loading()
      const response = await ws.getVisitTabulator()
      if(response.type == 'success'){
        this.items = response.data
      }
      this.loaded()
    },
    async storeItem () {
      this.loading()
      const response = await ws.storeVisitTabulator(this.newItem)
      this.showToast(response.type, response.message)
      if(response.type == 'success'){
        this.newItem = {
          min_visits: 1,
          max_visits: '',
          amount_per_visit: 0
        }
        await this.loadItems()
      }
      this.loaded()
    },
    async updateItem (item) {
      this.loading()
      const response = await ws.updateVisitTabulator({
        id: item.id,
        min_visits: item.min_visits,
        max_visits: item.max_visits,
        amount_per_visit: item.amount_per_visit
      })
      this.showToast(response.type, response.message)
      if(response.type == 'success'){
        await this.loadItems()
      }
      this.loaded()
    },
    async deleteItem (item) {
      this.loading()
      const response = await ws.deleteVisitTabulator(item.id)
      this.showToast(response.type, response.message)
      if(response.type == 'success'){
        await this.loadItems()
      }
      this.loaded()
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message})
    },
    loading(){
      store.commit('loading')
    },
    loaded(){
      store.commit('loaded')
    }
  }
}
</script>
